export interface Event {
  id: string
  title: string
  description: string
  date: string
  time: string
  type: "tournament" | "community" | "meetup" | "season"
  game?: string
  region?: string
  online: boolean
  spotsTotal?: number
  spotsTaken?: number
}

export const events: Event[] = [
  {
    id: "1",
    title: "Summer 2026 Registration Opens",
    description: "Registration for all Summer 2026 leagues opens. Annual members get early access starting May 25.",
    date: "2026-06-01",
    time: "12:00 PM EST",
    type: "season",
    online: true
  },
  {
    id: "2",
    title: "Valorant Community Night",
    description: "Open lobbies for all Valorant players. Meet potential teammates, play casual matches, and hang out.",
    date: "2026-05-22",
    time: "8:00 PM EST",
    type: "community",
    game: "Valorant",
    online: true
  },
  {
    id: "3",
    title: "Northeast IRL Meetup - Boston",
    description: "Meet fellow GameNight League players in person! We've reserved space at a local bar with gaming setups.",
    date: "2026-05-30",
    time: "6:00 PM EST",
    type: "meetup",
    region: "Northeast",
    online: false,
    spotsTotal: 40,
    spotsTaken: 28
  },
  {
    id: "4",
    title: "Rocket League 2v2 Tournament",
    description: "Special one-day tournament open to all skill levels. Prizes for top 3 teams.",
    date: "2026-06-08",
    time: "2:00 PM EST",
    type: "tournament",
    game: "Rocket League",
    online: true,
    spotsTotal: 32,
    spotsTaken: 24
  },
  {
    id: "5",
    title: "Summer 2026 Season Starts",
    description: "First matches for all Summer 2026 leagues begin this week.",
    date: "2026-06-15",
    time: "Various",
    type: "season",
    online: true
  },
  {
    id: "6",
    title: "Apex Legends Community Night",
    description: "Open lobbies for Apex players. Trios and duos welcome. Great way to find your next squad.",
    date: "2026-05-29",
    time: "9:00 PM EST",
    type: "community",
    game: "Apex Legends",
    online: true
  },
  {
    id: "7",
    title: "West Coast IRL Meetup - LA",
    description: "SoCal players, come hang out! Food, drinks, and gaming at a local esports venue.",
    date: "2026-06-14",
    time: "5:00 PM PST",
    type: "meetup",
    region: "West",
    online: false,
    spotsTotal: 50,
    spotsTaken: 31
  },
  {
    id: "8",
    title: "League of Legends ARAM Night",
    description: "Casual ARAM games with the community. No ranks, no pressure, just fun.",
    date: "2026-06-05",
    time: "7:00 PM EST",
    type: "community",
    game: "League of Legends",
    online: true
  },
  {
    id: "9",
    title: "Call of Duty Warzone Tournament",
    description: "Quads tournament with cash prizes. Bring your squad or get matched with teammates.",
    date: "2026-06-21",
    time: "3:00 PM EST",
    type: "tournament",
    game: "Call of Duty",
    online: true,
    spotsTotal: 20,
    spotsTaken: 12
  },
  {
    id: "10",
    title: "Southeast IRL Meetup - Atlanta",
    description: "First ever Atlanta meetup! Join us for games, food, and meeting your online teammates IRL.",
    date: "2026-06-28",
    time: "6:00 PM EST",
    type: "meetup",
    region: "Southeast",
    online: false,
    spotsTotal: 35,
    spotsTaken: 19
  }
]

export const eventTypes = ["All", "tournament", "community", "meetup", "season"] as const
export type EventType = typeof eventTypes[number]
